import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login: React.FC = () => {
  const nav = useNavigate();
  const { login } = useAuth();
  const [emailOrUsername, setId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await login(emailOrUsername, password);
      nav('/plots');
    } catch (err: any) {
      setError(err?.message || 'Login failed');
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="w-full max-w-sm">
        <div className="p-6 rounded-2xl bg-gradient-to-b from-gray-900/80 via-gray-900/70 to-gray-900/80 border border-gray-800 shadow-xl">
          <div className="flex items-center gap-2 mb-4">
            <i className="fas fa-seedling text-green-400"></i>
            <h2 className="text-xl font-semibold">Welcome back to AuraFarm</h2>
          </div>
          <p className="text-sm text-gray-400 mb-4">Sign in to manage plots, trade on the market, and grow your tycoon.</p>
          {error && (
            <div className="mb-3 px-3 py-2 rounded bg-red-900/30 border border-red-700 text-red-300 text-sm">
              {error}
            </div>
          )}
          <form className="space-y-3" onSubmit={onSubmit}>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Email or Username</label>
              <input
                className="w-full px-3 py-2 rounded-lg bg-gray-800 text-white border border-gray-700 outline-none focus:border-green-500"
                placeholder="you@farm.com or username"
                value={emailOrUsername}
                onChange={(e) => setId(e.target.value)}
              />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Password</label>
              <input
                className="w-full px-3 py-2 rounded-lg bg-gray-800 text-white border border-gray-700 outline-none focus:border-green-500"
                placeholder="••••••••"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button className="w-full px-4 py-2 rounded-lg bg-green-600 hover:bg-green-500 font-medium">Enter Farm</button>
          </form>
          <div className="mt-4 text-xs text-gray-400 flex items-center justify-between">
            <span>New here?</span>
            <Link to="/register" className="text-green-300 hover:text-green-200">Create an account</Link>
          </div>
        </div>
        <div className="mt-3 text-center text-xs text-gray-500">Secure login · Sustainable growth</div>
      </div>
    </div>
  );
};

export default Login;